import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.82 7.067a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5m0-3a.75.75 0 1 1 0 1.501.75.75 0 0 1 0-1.5m6.363 4.863a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m0 2.999a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m2.599-9.71a.75.75 0 0 0-1.06 0l-10.5 10.498a.75.75 0 1 0 1.06 1.06l10.5-10.497a.75.75 0 0 0 0-1.06"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })